// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": `#16b3d5`,
	"successColor": `#4caf50`,
	"errorColor": `#f44336`,
	"primaryFont": `"Nunito", sans-serif`,
	"activeColor": `#6b778c`,
	"textPrimaryColor": `#0f265c`,
	"textSecColor": `#909090`,
	"warningColor": `#ff9800`
};
export default ___CSS_LOADER_EXPORT___;
